import { Check } from "lucide-react";
import React from "react";

const Checkbox = ({
  checked = true,
  onChange,
  className = "",
  disabled = false,
  ...props
}) => (
  <button
    type="button"
    className={`
      flex items-center justify-center w-5 h-5 rounded border
      ${checked ? "bg-[#0832DE] border-[#0832DE]" : "bg-white border-gray-300"}
      ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
      ${className}
    `}
    aria-checked={checked}
    aria-disabled={disabled}
    tabIndex={0}
    onClick={(e) => {
      e.stopPropagation();
      if (!disabled && onChange) onChange(!checked);
    }}
    {...props}
  >
    {checked && <Check className="stroke-white" />}
  </button>
);

export default Checkbox;
